export const TYPE_IOS = 0;
export const TYPE_ANDROID = 1;
export const TYPE_WEB = 2;



// WEBPACK FOOTER //
// src/utils/case-button-types.js